import React, { useState, useEffect } from 'react';
import './NewOrder.css'; // Reutilizamos los estilos del formulario de nueva orden

const EditOrderModal = ({ order, onSave, onClose }) => {
  const [customerName, setCustomerName] = useState('');
  const [address, setAddress] = useState('');
  const [items, setItems] = useState([]);

  // Cuando la orden cambia, llenamos el formulario
  useEffect(() => {
    if (order) {
      setCustomerName(order.customer_name || '');
      setAddress(order.address || '');
      setItems(order.items ? [...order.items] : [{ quantity: 1, name: '', notes: '' }]);
    }
  }, [order]);

  const handleItemChange = (index, event) => {
    const values = [...items];
    values[index][event.target.name] = event.target.value;
    setItems(values);
  };

  const handleAddItem = () => {
    setItems([...items, { quantity: 1, name: '', notes: '' }]);
  };

  const handleRemoveItem = (index) => {
    if (items.length > 1) {
      const values = [...items];
      values.splice(index, 1);
      setItems(values);
    }
  };

  const handleSaveChanges = () => {
    const updatedData = {
      customer_name: customerName,
      address: order.delivery_type === 'A domicilio' ? address : order.address,
      items: items.map(item => ({
        ...item,
        quantity: Number(item.quantity)
      }))
    };
    onSave(order.id, updatedData);
  };
  
  if (!order) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Editar Orden de {order.customer_name}</h3>
        
        {order.delivery_type === 'A domicilio' && (
          <div className="form-group">
            <label>Dirección de Entrega</label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
        )}

        <h4>Productos</h4>
        {items.map((item, index) => (
          <div key={index} className="item-row">
            <input type="number" name="quantity" placeholder="Cant." value={item.quantity} onChange={e => handleItemChange(index, e)} className="input-qty" min="1" required />
            <input type="text" name="name" placeholder="Producto" value={item.name} onChange={e => handleItemChange(index, e)} className="input-name" required />
            <input type="text" name="notes" placeholder="Notas" value={item.notes} onChange={e => handleItemChange(index, e)} className="input-notes" />
            {items.length > 1 && (<button type="button" className="remove-item-btn" onClick={() => handleRemoveItem(index)}>-</button>)}
          </div>
        ))}
        <button type="button" className="add-item-btn" onClick={handleAddItem}>+ Añadir Producto</button>

        <div className="form-actions">
          <button onClick={handleSaveChanges} className="submit-btn">Guardar Cambios</button>
          <button onClick={onClose} className="cancel-btn">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default EditOrderModal;